module.exports = __webpack_public_path__ + "static/media/title_9.492fe1ea.svg";